<template>
    <div class="o-dashboard">
        <c-loader-container :loading="loading">
            <div class="o-dashboard__breadcrumbs">
                <c-breadcrumbs></c-breadcrumbs>
            </div>
            <template v-if="request">
                <h2 class="margin-b-8">Berichtencentrum</h2>
                <p>Sta in contact met alle personen die betrokken zijn in deze aanvraag.</p>

                <router-link class="c-panel c-panel--border c-panel--small c-panel--link td-none margin-b-8" :to="{ name: 'chat', params: { id: $route.params.id }, query: { assigment: 'applicant' } }">
                    <div class="fw-medium">{{request.opdrachtgever.user.name}}</div>
                    <div class="fs-small">Aanvrager</div>
                </router-link>

                <template v-for="translation in request.vertalingen">
                    <router-link :to="{ name: 'chat', params: { id: $route.params.id }, query: { assigment: client.id } }"  class="c-panel c-panel--border c-panel--small c-panel--link td-none margin-b-8" :key="'chatter-' + client.id" v-for="client in translation.opdrachtnemers">
                        <div class="fw-medium">{{client.opdrachtnemer.user.name}}</div>
                        <div class="fs-small">Vertaler {{translation.brontaal.taal}} -> {{translation.doeltaal.taal}}</div>
                    </router-link>
                </template>
            </template>
        </c-loader-container>
    </div>
</template>

<script>
import CLoaderContainer from '@components/loader/Container';
import CBreadcrumbs from '@components/Breadcrumbs';
import { mapState } from 'vuex';

export default {
    components: { CLoaderContainer, CBreadcrumbs },
    computed: {
        ...mapState({
            request: (state) => state.request.data
        })
    },
    data() {
        return {
            loading: true
        };
    },
    mounted() {
        this.$store.dispatch('request/load', this.$route.params.id).then( () => {
            this.loading = false;
        });
    }
}
</script>
